import { createSlice } from "@reduxjs/toolkit";
import { ceaProfileFilterPayload } from "../../constData/filterRequestPayloadCeaProfile";

const initialState = {
  ceaProfileFilter: ceaProfileFilterPayload,
};

const drmCeaProfileTableFilterSlice = createSlice({
  name: "drmCeaProfileFilterPayload",
  initialState,
  reducers: {
    setCeaProfileFilter: (state, action) => {
      state.ceaProfileFilter = { ...state.ceaProfileFilter, ...action.payload };
    },
    resetCeaProfileFilter: (state) => {
      state.ceaProfileFilter = ceaProfileFilterPayload;
    },
    resetCeaColumnTableFilters: (state) => {
      state.ceaProfileFilter = {
        ...state.ceaProfileFilter,
        filters: {
          ...(state.ceaProfileFilter?.filters || {}),
          fileNames: [],
          uploadedDate: { date: [], operator: "" },
          fileSize: { operator: "", params: [] },
          isDownloaded: [],
        },
      };
    },
  },
});

export const { setCeaProfileFilter, resetCeaProfileFilter, resetCeaColumnTableFilters } = drmCeaProfileTableFilterSlice.actions;
export default drmCeaProfileTableFilterSlice.reducer;
